import React, { useState } from "react";
import {
  Block,
  BlockContent,
  BlockHead,
  BlockTitle,
  Button,
  PreviewCard,
} from "../../components/Component";
import Logo from "../../images/logo.svg";
import LogoDark from "../../images/logo-dark.svg";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Form, Spinner } from "reactstrap";
import { AppText } from "../../utils";
import { changeEmail } from "./AuthData";

const ChangeEmail = () => {
  const { errors, register, handleSubmit } = useForm();
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const onFormSubmit = (formData) => {
    var data = formData;
    data["token"] = location.state.token;
    setLoading(true)
    changeEmail(data, (data, error) => {
      setLoading(false)
      if (error === null) {
        setTimeout(() => {
          history.push({
            pathname: `${process.env.PUBLIC_URL}/otp-verification`,
          state: {
            // type: ConfirmationType.createPassword,
            token: location.state.token,
            email: formData.email.toLowerCase(),
          },
          });
        }, 0);
      } else {
        setLoading(false);
      }
    });
  };

  return (
    <React.Fragment>
      <Head title="Reset your password" />
      <PageContainer>
        <Block className="nk-block-middle nk-auth-body  wide-xs">
          <div className="brand-logo pb-4 text-left mx-4">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img
                className="logo-light logo-img logo-img-lg"
                src={Logo}
                alt="logo"
              />
              <img
                className="logo-dark logo-img logo-img-lg"
                src={LogoDark}
                alt="logo-dark"
              />
            </Link>
          </div>
          <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
            <BlockHead>
              <BlockContent>
                <BlockTitle tag="h5">Set your new email</BlockTitle>
              </BlockContent>
            </BlockHead>
            <Form
              className="form-validation"
              onSubmit={handleSubmit(onFormSubmit)}
            >
              <div className="form-group">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="newpassword">
                    New email
                  </label>
                </div>
                <div className="form-control-wrap">
                  <input
                    type="text"
                    bssize="lg"
                    id="fv-email"
                    name="email"
                    ref={register({
                      required: true,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: AppText.invalidEmail,
                      },
                    })}
                    className="form-control-lg form-control"
                  />
                  {errors.email && errors.email.type === "required" && (
                    <span className="invalid">This field is required</span>
                  )}
                  {errors.email && errors.email.type === "pattern" && (
                    <span className="invalid">{errors.email.message}</span>
                  )}
                </div>
              </div>
              <div className="form-group">
                <Button
                  type="submit"
                  color="primary"
                  size="lg"
                  className="btn-block"
                >
                  {loading ? <Spinner size="sm" color="light" /> : "Continue"}
                </Button>
              </div>
            </Form>
          </PreviewCard>
        </Block>
        <div className="gap-100px" />
        <AuthFooter />
      </PageContainer>
    </React.Fragment>
  );
};
export default ChangeEmail;
